module.exports = __webpack_public_path__ + "img/battery-bolt-regular.727d8c60.svg";